import { useMutation, useQueryClient } from '@tanstack/react-query';
import useApiClient from '../../Shared/services/api';
import { updateArtEventStatus } from '../service/service';
import {
  UpdateArtEventRequest,
  UpdateArtEventResponse,
} from '../interfaces/editArtEventInterfaces';
import { ArtEventEndpointQueryKeys } from '../../Shared/constants/artEvent/endpoints';
import { useAppContext } from '../../Shared/store/appContext';
import { SET_SELECTED_ART_EVENT_STATUS } from '../../Shared/store/actions/types';
import { ART_EVENT_STATUS } from '../constants/artEventStatus';

export const useActivateArtEventMutation = () => {
  const api = useApiClient();
  const queryClient = useQueryClient();
  const { state, dispatch } = useAppContext();

  return useMutation<
    UpdateArtEventResponse | null,
    Error,
    UpdateArtEventRequest
  >({
    mutationFn: (data: UpdateArtEventRequest) =>
      updateArtEventStatus(api, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [ArtEventEndpointQueryKeys.GET_ART_EVENTS],
      });

      if (state.selectedArtEventId === variables.artEvent.artEventID) {
        dispatch({
          type: SET_SELECTED_ART_EVENT_STATUS,
          payload: ART_EVENT_STATUS.ACTIVE,
        });
      }
    },
  });
};
